import { Link } from 'react-router-dom';
import {
  ORDAN_PRIVACY_POLICY_EFFECTIVE_DATE,
  ORDAN_PRIVACY_POLICY_VERSION,
  ORDANPrivacyPolicySections,
  PLAY_STORE_APP_NAME,
  PLAY_STORE_DEVELOPER_NAME,
} from '@/content/noblexPrivacyPolicy';

const PrivacyPolicyPage = () => {
  return (
    <div className="auth-privacy-doc">
      <h1 className="auth-page-title">Privacy Policy</h1>
      <p className="auth-page-subtitle">
        {PLAY_STORE_APP_NAME} · Developer: {PLAY_STORE_DEVELOPER_NAME} · Effective{' '}
        {ORDAN_PRIVACY_POLICY_EFFECTIVE_DATE} · Version {ORDAN_PRIVACY_POLICY_VERSION}
      </p>

      <div className="auth-form-surface auth-privacy-doc__body">
        {ORDANPrivacyPolicySections.map((section) => (
          <section key={section.title} className="auth-privacy-doc__section">
            <h2 className="auth-privacy-doc__heading">{section.title}</h2>
            {section.paragraphs.map((paragraph) => (
              <p key={paragraph.slice(0, 48)} className="auth-privacy-doc__p">
                {paragraph}
              </p>
            ))}
          </section>
        ))}
      </div>

      <p className="auth-login-footnote" style={{ marginTop: 20 }}>
        <Link to="/login" className="auth-forgot-link">
          Back to sign in
        </Link>
      </p>
    </div>
  );
};

export default PrivacyPolicyPage;
